import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReadOnlyField from "../DocumentView/ReadOnlyField";
import "./DocumentEdit.css";
import "../DocumentRegister/DocumentRegister.css";

const CommonEdit = ({
  folderName,
  title,
  autoNumber,
  registerDate,
  registrant,
  viewCount,
  onFormDataChange,
}) => {
  const [localTitle, setLocalTitle] = useState(title || "");
  const [isComposing, setIsComposing] = useState(false);

  useEffect(() => {
    setLocalTitle(title || "");
  }, [title]);

  // 文字の幅カウント
  const getCharacterWidth = (text) => {
    if (!text) return 0;
    let width = 0;
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const code = char.charCodeAt(0);
      if (
        (code >= 0x3040 && code <= 0x309f) || // Hiragana
        (code >= 0x30a0 && code <= 0x30ff) || // Katakana
        (code >= 0x4e00 && code <= 0x9fff) || // CJK Ideographs
        (code >= 0xff00 && code <= 0xffef) || // Full-width ASCII
        (code >= 0x3000 && code <= 0x303f) // Full-width symbols
      ) {
        width += 2;
      } else {
        width += 1;
      }
    }
    return width;
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = (e) => {
    setIsComposing(false);
    handleTitleChange(e);
  };

  const handleTitleChange = (e) => {
    // IME構成中は検証スキップ（ただし値は更新）
    if (isComposing && e.type !== "compositionend") {
      const value = e.target.value;
      setLocalTitle(value);
      if (onFormDataChange) {
        onFormDataChange("title", value);
      }
      return;
    }

    const value = e.target.value;
    const maxWidth = 128; // 全角64文字

    const currentWidth = getCharacterWidth(value);
    if (currentWidth > maxWidth) {
      let truncatedValue = "";
      let width = 0;
      for (let i = 0; i < value.length; i++) {
        const char = value[i];
        const code = char.charCodeAt(0);
        const charWidth =
          (code >= 0x3040 && code <= 0x309f) ||
          (code >= 0x30a0 && code <= 0x30ff) ||
          (code >= 0x4e00 && code <= 0x9fff) ||
          (code >= 0xff00 && code <= 0xffef) ||
          (code >= 0x3000 && code <= 0x303f)
            ? 2
            : 1;

        if (width + charWidth > maxWidth) break;
        truncatedValue += char;
        width += charWidth;
      }
      setLocalTitle(truncatedValue);
      if (onFormDataChange) {
        onFormDataChange("title", truncatedValue);
      }
      return;
    }

    setLocalTitle(value);
    if (onFormDataChange) {
      onFormDataChange("title", value);
    }
  };

  return (
    <div className="common-edit">
      <div className="form-row">
        <span className="form-label">
          フォルダー <span className="required">*</span>
        </span>
        <div className="form-value read-only">{folderName}</div>
      </div>

      <div className="form-row common-edit__title-row">
        <span className="form-label">
          タイトル <span className="required">*</span>
        </span>
        <div className="form-input-group common-edit__title-group">
          <input
            type="text"
            className="form-input"
            value={localTitle}
            onChange={handleTitleChange}
            onCompositionStart={handleCompositionStart}
            onCompositionEnd={handleCompositionEnd}
          />
          <div className="auto-number-group read-only">
            <span className="form-label auto-number-label">オートナンバー</span>
            <span className="auto-number-value">{autoNumber}</span>
          </div>
        </div>
      </div>

      <div className="common-edit__grid">
        <div className="common-edit__grid-column">
          <ReadOnlyField label="登録日時" value={registerDate} />
        </div>
        <div className="common-edit__grid-column">
          <ReadOnlyField label="登録者" value={registrant} />
          <ReadOnlyField label="参照回数" value={viewCount} />
        </div>
      </div>
    </div>
  );
};

CommonEdit.propTypes = {
  folderName: PropTypes.string,
  title: PropTypes.string,
  autoNumber: PropTypes.string,
  registerDate: PropTypes.string,
  registrant: PropTypes.string,
  viewCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFormDataChange: PropTypes.func,
};

CommonEdit.defaultProps = {
  folderName: "",
  title: "",
  autoNumber: "",
  registerDate: "",
  registrant: "",
  viewCount: "",
  onFormDataChange: () => {},
};

export default CommonEdit;
